<template>
  <div class="c-base-transaction-tabs">
    <div class="tabs">
      <ul>
        <li
          v-for="(tab, index) in tabs"
          :key="index"
          :class="{ 'is-active': tabIndex === index }"
        >
          <a
            @click="setTabIndex(index)"
            class="has-text-weight-bold is-flex is-size-6-tablet"
          >
            {{ tab.title }}
          </a>
        </li>
      </ul>
    </div>

    <div class="c-base-transaction-tabs__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tabIndex: 0,
    }
  },
  methods: {
    setTabIndex(index) {
      this.tabIndex = index
      this.$emit('tabClicked', index)
    },
  },
}
</script>
<style lang="scss">
.c-base-transaction-tabs {
  padding: 0 0 1.5em;

  ul {
    border-bottom: solid 2px $gray-3;
  }

  li {
    @media (min-width: $tablet) {
      width: auto;
    }
  }

  li a {
    padding: 1em;
    color: #abb3bb;
    font-size: 14px;
    border-bottom-width: 2px;
    border-bottom-color: transparent;
    &:hover,
    &:focus {
      color: $gray-5;
      border-bottom-color: $gray-5;
    }
    @media (min-width: $tablet) {
      padding: 1em 1.5em;
    }
  }

  li.is-active a {
    color: $primary;
    border-bottom-color: $primary;
  }

  @media (max-width: $tablet) {
    .tabs {
      margin-bottom: 1rem;
    }
  }
}
</style>
